import DarkTheme from './DarkTheme';
import LightTheme from './LightTheme';

export default {
    Dark: DarkTheme,
    Light: LightTheme
};
